import { styled, Box } from "@mui/material";
import MyImage from "../../../assets/pic.png";
import Resume from "../../../assets/resume.pdf";
import { Constants } from "../../../data/constants";
import TuanTechStackImg from "../../../assets/TuanTechStack.png";
import {
  CustomButton,
  SectionWrapper,
  TitleWrapper,
} from "../../../styles/sectionStyles";
import aboutMeInfo from "../../../data/AboutMe.json";
/*import hanley from "../../../assets/fonts/hanley/hanley-pro-script.otf";*/
// https://willparks.dev/how-to-import-fonts-into-react-components-using-typescript/
// https://stackoverflow.com/questions/53742766/cannot-import-local-fonts-with-typescript
// https://www.designcise.com/web/tutorial/how-to-fix-cannot-find-module-error-when-importing-fonts-with-typescript

import { StyleSheet, Font } from '@react-pdf/renderer';
import { useEffect } from "react";

// regisrering fonts using @react-pdf/renderer (for typescript)
//Font.register({
//    family: "Hanley",
//    src: hanley,
//});

const AboutMeContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignSelf: "center",
  "& img": {
    width: 400,
    [theme.breakpoints.down("sm")]: {
      width: 350,
    },
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

const DetailsWrapper = styled(Box)(({ theme }) => ({
  fontSize: 16,
  marginLeft: 15,
  "& .actions": {
    margin: "12px 0",
  },
  [theme.breakpoints.down("md")]: {
    margin: "10px 0 0 0",
  },
}));
export const AboutMe = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
      <SectionWrapper>
      <TitleWrapper>About Me</TitleWrapper>
      <AboutMeContainer>
        <img src={MyImage} />
        <DetailsWrapper>
          <div style={{ lineHeight: 1.4 } }>{aboutMeInfo.aboutMe}</div>
          <div className="actions">
            {/*<CustomButton>*/}
            {/*  <a href={Resume} rel="noreferrer" target="_blank">*/}
            {/*    View Resume*/}
            {/*  </a>*/}
            {/*</CustomButton>*/}
                      <CustomButton>
                          <a href={Constants.GithubLink} rel="noreferrer" target="_blank">
                              Github Profile
                          </a>
                      </CustomButton>
          </div>
          <img src={TuanTechStackImg} alt="TuanTechStack" />
        </DetailsWrapper>
      </AboutMeContainer>
    </SectionWrapper>
  );
};
